module.exports = __webpack_public_path__ + "static/media/naiwen_aileen_chang.386e8d4d.jpg";